import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    FormHelperText,
    FormControl,
    InputLabel,
    Select, MenuItem, CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import {hasPermission} from "../../sc-utilities";
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    helperText: {
        marginTop: '4px'
    },
    formControl: {
        width: "100%"
    }

});

export const types = [{value: "system", displayValue: "System file pattern"}, {value: "custom", displayValue: "Customer file pattern"}];

const FilePatternForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, permissions, CustomerIDPreviousState, fromEdit } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={(e) => {handleChange(e); setFieldValue('Key', e.target.value)}}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["short_name"] || "Short name"}
                                label={translations["short_name"] || "Short name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Pattern"
                                value={values.Pattern}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Pattern && touched.Patter)}
                                placeholder={translations['pattern'] || 'Pattern'}
                                label={translations['pattern'] || 'Pattern'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormHelperText className={classes.helperText} >{translations['example'] || 'Example'}: report_%ProductID%_%OrderID%_%ContainerID%_%ExternalID%_%SerialNumber%_%IMEI%</FormHelperText>
                            {hasPermission(permissions, 'system_file_pattern_create') ? (<><FormControl className={classes.formControl}
                                                                                                           margin={"dense"}>
                                <InputLabel
                                    shrink>{translations['file_pattern_type'] || "Please select file pattern type"}</InputLabel>
                                <Select
                                    name="CustomerID"
                                    label={translations['file_pattern_type'] || 'Please select file pattern type'}
                                    margin={"dense"}
                                    value={values?.CustomerID?.toString() || ''}
                                    onChange={handleChange}
                                    disabled={values?.CustomerID?.toString() === 'system' && fromEdit && CustomerIDPreviousState==='system'}
                                >
                                    {(types ? [...types] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                                {values?.CustomerID?.toString() === 'system'  ? <TextField
                                    name="Key"
                                    value={values?.Key ? updateKey(values?.Key) : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Key)}
                                    placeholder={translations['key'] || 'Key'}
                                    label={translations['key'] || 'Key'}
                                    margin={"dense"}
                                    fullWidth={true}
                                /> : null}
                            </>) : null}
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24}/> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(FilePatternForm);